// extracted by mini-css-extract-plugin
module.exports = {"box":"ForgotPass_box__2uJLC","title":"ForgotPass_title__2hZa6","button":"ForgotPass_button__2bLB0","link":"ForgotPass_link__3-L78"};